import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Check, Compass, CalendarClock } from "lucide-react";

const fmt = (d) => (d ? new Date(d + "T12:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "Date TBD");
const daysUntil = (d) => Math.round((new Date(d + "T12:00:00") - new Date(new Date().toDateString() + " 12:00")) / 86400000);

export const sortContract = (items) =>
  [...items].sort((a, b) => (a.due_date || "9999").localeCompare(b.due_date || "9999"));

function DueLabel({ item, isNext }) {
  if (item.done) return <Badge className="border-0 bg-status-complete/15 text-status-complete">Done</Badge>;
  if (!item.due_date) return isNext ? <Badge className="border-0 bg-primary/15 text-primary">Up next</Badge> : null;
  const n = daysUntil(item.due_date);
  const txt = n === 0 ? "Due today" : n > 0 ? `In ${n} day${n === 1 ? "" : "s"}` : "Date passed, check with Marlene";
  return <Badge className={`border-0 ${isNext ? "bg-primary/15 text-primary" : "bg-secondary text-muted-foreground"}`}>{isNext ? `Due next · ${txt}` : txt}</Badge>;
}

export function ContractTimeline({ items = [] }) {
  const list = sortContract(items);
  const nextId = list.findIndex((i) => !i.done);
  const done = list.filter((i) => i.done).length;
  if (!list.length) return null;
  return (
    <Card className="p-6 rounded-2xl" data-testid="contract-timeline">
      <div className="flex items-center justify-between gap-2 flex-wrap mb-4">
        <h2 className="font-heading text-xl font-semibold flex items-center gap-2"><Compass className="h-5 w-5 text-primary" /> Your contract timeline</h2>
        <span className="text-sm text-muted-foreground" data-testid="contract-progress">{done} of {list.length} done</span>
      </div>
      <div>
        {list.map((it, i) => {
          const isNext = i === nextId; const last = i === list.length - 1;
          return (
            <div key={`${it.label}-${i}`} className="flex gap-4" data-testid={`contract-item-${i}`}>
              <div className="flex flex-col items-center">
                <div className={`h-8 w-8 rounded-full flex items-center justify-center shrink-0 border-2 ${it.done ? "bg-status-complete border-status-complete text-white" : isNext ? "bg-primary border-primary text-primary-foreground ring-4 ring-primary/20" : "bg-background border-border text-muted-foreground"}`}>
                  {it.done ? <Check className="h-4 w-4" /> : <CalendarClock className="h-4 w-4" />}
                </div>
                {!last && <div className={`w-0.5 flex-1 min-h-[22px] ${it.done ? "bg-status-complete" : "bg-border"}`} />}
              </div>
              <div className="pb-5 flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className={`font-medium ${isNext ? "text-primary" : it.done ? "" : "text-foreground/80"}`}>{it.label}</p>
                  <DueLabel item={it} isNext={isNext} />
                </div>
                <p className="text-xs text-muted-foreground mt-0.5">{fmt(it.due_date)}</p>
                {it.note && <p className="text-sm text-muted-foreground mt-1">{it.note}</p>}
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-muted-foreground">Dates come from your contract and are entered by Marlene. Your purchase contract is the final word on deadlines.</p>
    </Card>
  );
}
